import React from 'react';
import './Chapters.scss';
import graphic from '../../assets/inlinePhoto3.svg';

function Chapter3() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">Moving to the Cloud to Meet Massive New Demand</h3>
      <p className="chapter__paragraph">
        In its early days, the pandemic hit the $99 billion entertainment industry particularly
        hard. People staying home from movie theaters led to a precipitous drop in theatrical
        revenue, while demand for streaming content grew almost immediately. Subscriptions to
        streaming services in the U.S. jumped 14% in 2021 alone, and the digital movie market
        accounted for 72% of the global theatrical and home/mobile entertainment market in 2021, up
        from just 48% in 2019, according to the Motion Picture Association.
      </p>

      <img src={graphic} alt="graphic" />
      <p style={{ fontFamily: 'cnnSansL', fontSize: '12px', color: '#666666' }}>
        Source: Motion Picture Association, 2022.
      </p>
      <p className="chapter__paragraph">
        But filling the entertainment pipeline to meet demand suddenly proved to be a major
        challenge. With production and postproduction houses closed and talent stuck at home, the
        answer for Company 3 was to shift much of its work to the cloud. To support the company’s
        postproduction facilities and its corporate networks, Keske had three main concerns for the
        technology that would support Company 3: Would it be accessible? Would it scale? And would
        it be secure?
      </p>
      <p className="chapter__paragraph">
        First, he addressed security. “Intel® is the number-one player in our industry,” Keske says,
        “and our on-premises infrastructure was already running securely on Intel® Xeon® Scalable
        processors. Understanding our responsibility for our own security measures, and trusting the
        security technology that AWS provides, the decision to shift to the cloud was easy.”
      </p>
    </section>
  );
}

export default Chapter3;
